import { loadAsyncComponent } from 'src/components/AsyncComponent';

export default loadAsyncComponent(
  () => import(/* webpackChunkName: "ProjectPage" */ './Container'),
  'page'
);

export { useFreestyleToolChips } from './services/useFreestyleToolChips';
export { useScoredOverlayData } from './services/useScoredOverlayData';
export { BlockAspectRatio } from './views/BlockAspectRatio';
export { BlockImageOverlay } from './views/BlockImageOverlay';
// TODO: Extract ImageOverlayTextForm from BlockImageOverlay and use it as separate view
export { ImageOverlayTextForm } from './views/BlockImageOverlay/views/ImageOverlayTextForm';
export { BlockImageStyle } from './views/BlockImageStyle';
